<p-dialog
    [(visible)]="isVisible"
    [modal]="true"
    [style]="{ width: '95vw' }"
    [contentStyle]="{ 'max-height': '80vh', overflow: 'hidden' }"
    styleClass="create-filter-config-dialog"
    header="Add Filter Configuration"
    appendTo="body"
    (onHide)="dt.clear()"
>
    <div class="my-4">
        <label for="configName" class="block mb-2 font-medium">Configuration Name *</label>
        <input
            id="configName"
            pInputText
            type="text"
            [formControl]="configName"
            placeholder="Enter configuration name"
            class="w-full"
        />
    </div>
    <label for="componentExclude" class="block mb-2 font-medium">Components to exclude *</label>
    <div class="st-border my-2">
        <p-table
            #dt
            [(selection)]="selectedComponents"
            [value]="displayedComponents"
            [scrollable]="true"
            [lazy]="true"
            [rows]="componentLimit"
            [loading]="isLoading"
            [totalRecords]="totalRecords"
            (onLazyLoad)="loadComponentAnchors($event)"
            dataKey="key"
            scrollHeight="55vh"
            class="h-full flex flex-col"
            showGridlines
        >
            <ng-template #caption>
                <div class="flex justify-between items-center h-full w-full">
                    <span class="font-semibold mr-auto ml-2"
                        >Components
                        <i
                            class="pi pi-info-circle cursor-pointer"
                            pTooltip="Selected components will move to the top of the table. These will be filtered out in your workspace."
                            tooltipPosition="right"
                        ></i>
                    </span>
                </div>
            </ng-template>
            <ng-template #header>
                <tr>
                    @for (prop of props; track prop) {
                        <th>{{ prop.label }}</th>
                    }
                </tr>
                <tr>
                    @for (prop of props; track prop) {
                        <th [style.text-align]="prop.field === 'exclude' ? 'center' : null">
                            @if (prop.field === 'exclude') {
                                <p-tableHeaderCheckbox
                                    pTooltip="Exclude all"
                                    tooltipPosition="bottom"
                                    [showDelay]="300"
                                ></p-tableHeaderCheckbox>
                            }
                            @if (prop.field === 'displayName') {
                                <p-columnFilter
                                    type="text"
                                    [field]="prop.field"
                                    matchMode="contains"
                                ></p-columnFilter>
                            }
                        </th>
                    }
                </tr>
            </ng-template>
            <ng-template #body let-component let-rowIndex="rowIndex">
                <tr
                    class="component-row"
                    [class.p-datatable-row-selected]="isSelectedComponent(component)"
                    (click)="toggleComponentSelection(component)"
                >
                    @for (prop of props; track prop) {
                        <td [style.text-align]="prop.field === 'exclude' ? 'center' : null">
                            @if (prop.field === 'exclude') {
                                <p-tableCheckbox
                                    [value]="component"
                                    pTooltip="Exclude component"
                                    tooltipPosition="bottom"
                                    [showDelay]="300"
                                    (click)="$event.stopPropagation()"
                                ></p-tableCheckbox>
                            }
                            @if (prop.field !== 'exclude') {
                                @if (prop.field === 'displayName') {
                                    <span>{{ component.displayName }}</span>
                                }
                                @if (prop.field === 'validVersion.fullName') {
                                    <span>{{ component.validVersion?.fullName }}</span>
                                }
                                @if (prop.field === 'componentCodeAnchorKey') {
                                    <span>{{ component.componentCodeAnchorKey }}</span>
                                }
                                @if (prop.field === 'validVersion.generation') {
                                    <span>{{ component.validVersion?.generation }}</span>
                                }
                                @if (prop.field === 'validVersion.isActive') {
                                    <i
                                        [class]="
                                            component.validVersion?.isActive
                                                ? 'pi pi-check text-green-500'
                                                : 'pi pi-times text-red-500'
                                        "
                                    ></i>
                                }
                            }
                        </td>
                    }
                </tr>
                @if (isLastComponent(component) && hasMore) {
                    <tr>
                        <td [attr.colspan]="props.length" class="p-0 h-8">
                            <div
                                class="flex items-center h-full w-full cursor-pointer text-primary px-2"
                                (click)="!isLoading && loadMore()"
                            >
                                @if (isLoading) {
                                    <p-progress-spinner
                                        ariaLabel="Loading..."
                                        class="h-8! w-8! ml-2"
                                    />
                                } @else {
                                    <i class="pi pi-plus-circle mr-2"></i>
                                    <span>Load More...</span>
                                }
                            </div>
                        </td>
                    </tr>
                }
            </ng-template>
        </p-table>
    </div>
    <ng-template #footer>
        <p-button
            label="Cancel"
            icon="pi pi-times"
            (onClick)="onClose()"
            variant="outlined"
        ></p-button>
        <p-button
            label="Save"
            icon="pi pi-check"
            (onClick)="onSave()"
            [disabled]="configName.invalid || selectedComponents.length === 0"
        ></p-button>
    </ng-template>
</p-dialog>
